import { useEffect, useState } from "react";

/**
 * Возвращает `true`, когда пользователь открыл print-preview / запустил печать.
 *
 * Используется для авто-переключения master-detail → feed при печати
 * (фича 024, README §Edge cases: «Print/PDF: feed-режим (master-detail
 * схлопывается)»).
 *
 * Реализация через `window.matchMedia('print')`. SSR-safe.
 */
export function usePrintMode(): boolean {
	const [isPrint, setIsPrint] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;

		const mq = window.matchMedia("print");
		setIsPrint(mq.matches);

		const onChange = (e: MediaQueryListEvent) => setIsPrint(e.matches);
		mq.addEventListener("change", onChange);

		// Дополнительно слушаем beforeprint/afterprint — некоторые браузеры
		// не триггерят `change` на 'print' media query.
		const onBefore = () => setIsPrint(true);
		const onAfter = () => setIsPrint(false);
		window.addEventListener("beforeprint", onBefore);
		window.addEventListener("afterprint", onAfter);

		return () => {
			mq.removeEventListener("change", onChange);
			window.removeEventListener("beforeprint", onBefore);
			window.removeEventListener("afterprint", onAfter);
		};
	}, []);

	return isPrint;
}
